import React from 'react';
import Support1 from "../assets/images/support1.svg"
import Withdrawal from "../assets/images/fastest_withdrawal.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import TopWinners from '../components/TopWinners';
import GameRates from '../components/GameRates';
import Service from '../components/Service';
import AvailableGames from '../components/AvailableGames';
import FAQs from '../components/FAQs';
import SocialIcons from '../components/SocialIcons';
import InfoSection from '../components/InfoSection';
import AvailableGamesSkeleton from '../components/AvailableGamesSkeleton';
import GameRatesSkeleton from '../components/GameRatesSkeleton';
import StarlineGames from '../components/StarlineGames';
import JackpotGames from '../components/JackpotGames';
import JackpotGamesSkeleton from '../components/JackpotGamesSkeleton ';
import StarlineGamesSkeleton from '../components/StarlineGamesSkeleton';
import { openStar123Download } from '../hooks/useMobileInstallPrompt';

const HERO_PUBLIC = process.env.PUBLIC_URL || '';

const HERO_RATE_ITEMS = [
    { id: 'single-digit', label: 'Single Digit', names: ['single digit'], fallback: '10' },
    { id: 'jodi-digit', label: 'Jodi Digit', names: ['jodi digit', 'jodi digits'], fallback: '100' },
    { id: 'single-pana', label: 'Single Pana', names: ['single pana'], fallback: '160' },
    { id: 'double-pana', label: 'Double Pana', names: ['double pana'], fallback: '320' },
];

function resolveHeroRate(games, names, fallback) {
    if (!Array.isArray(games)) return fallback;
    const match = games.find((game) => {
        const name = String(game?.name || '').toLowerCase().trim();
        return names.some((key) => name === key || name.includes(key));
    });
    if (match == null || match.rate == null || match.rate === '') return fallback;
    const raw = String(match.rate).replace(/[^\d.]/g, '');
    if (!raw) return fallback;
    const num = Number(raw);
    if (!Number.isFinite(num)) return fallback;
    return Number.isInteger(num) ? String(num) : String(num);
}

function Home({ data }) {
    const heroRates = HERO_RATE_ITEMS.map((item) => ({
        ...item,
        value: resolveHeroRate(data?.games, item.names, item.fallback),
    }));
    const appLink = data.app_link ?? "https://d2elum7hsyw4cy.cloudfront.net/star123-v1.0.0.apk";
    return (
        <>
            <div className="home-page-shell">
                <div className="hero-bubbles" aria-hidden="true">
                    <div className="hero-bubble bubble-1" />
                    <div className="hero-bubble bubble-2" />
                    <div className="hero-bubble bubble-3" />
                    <div className="hero-bubble bubble-4" />
                    <div className="hero-bubble bubble-5" />
                    <div className="hero-bubble bubble-6" />
                    <div className="hero-bubble bubble-7" />
                    <div className="hero-bubble bubble-8" />
                    <div className="hero-bubble bubble-9" />
                    <div className="hero-bubble bubble-10" />
                    <div className="hero-bubble bubble-11" />
                    <div className="hero-bubble bubble-12" />
                    <div className="hero-bubble bubble-13" />
                    <div className="hero-bubble bubble-14" />
                    <div className="hero-bubble bubble-15" />
                    <div className="hero-bubble bubble-16" />
                    <div className="hero-bubble bubble-17" />
                    <div className="hero-bubble bubble-18" />
                    <div className="hero-bubble bubble-19" />
                    <div className="hero-bubble bubble-20" />
                    <div className="hero-bubble bubble-21" />
                    <div className="hero-bubble bubble-22" />
                    <div className="hero-bubble bubble-23" />
                    <div className="hero-bubble bubble-24" />
                    <div className="hero-bubble bubble-25" />
                    <div className="hero-bubble bubble-26" />
                    <div className="hero-bubble bubble-27" />
                    <div className="hero-bubble bubble-28" />
                    <div className="hero-bubble bubble-29" />
                    <div className="hero-bubble bubble-30" />
                    <div className="hero-bubble bubble-31" />
                    <div className="hero-bubble bubble-32" />
                </div>
                <div className="home-page-content">
                <section className="section-1 homescreen">
                    <div className="homescreen-inner">
                        <div className="homescreen-copy">
                            <p className="homescreen-kicker">★ INDIA'S MOST TRUSTED ★</p>
                            <h1 className="homescreen-title">SATTA MATKA APP</h1>
                            <div className="homescreen-brand">
                                <span className="homescreen-brand__rule" aria-hidden="true" />
                                <span className="homescreen-brand__name">
                                    Star<span className="homescreen-brand__num">123</span>
                                </span>
                                <span className="homescreen-brand__rule" aria-hidden="true" />
                            </div>
                        </div>

                        <div className="homescreen-visual">
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`${HERO_PUBLIC}/star123_matka_hero_background-800.webp 800w, ${HERO_PUBLIC}/star123_matka_hero_background-1200.webp 1200w, ${HERO_PUBLIC}/star123_matka_hero_background.webp 1600w`}
                                    sizes="(max-width: 575px) 92vw, (max-width: 991px) 70vw, 560px"
                                />
                                <img
                                    className="homescreen-visual__img"
                                    src={`${HERO_PUBLIC}/star123_matka_hero_background.png`}
                                    srcSet={`${HERO_PUBLIC}/star123_matka_hero_background.png 1600w`}
                                    sizes="(max-width: 575px) 92vw, (max-width: 991px) 70vw, 560px"
                                    width={1600}
                                    height={747}
                                    alt="Star123 Satta Matka balls 9, 1 and 5 with crown"
                                    decoding="async"
                                    fetchPriority="high"
                                />
                            </picture>
                        </div>

                        <div className="homescreen-features" role="list">
                            <div className="homescreen-feature" role="listitem">
                                <span className="homescreen-feature__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M13 2 4 14h7l-1 8 10-14h-7l0-6z" />
                                    </svg>
                                </span>
                                <span className="homescreen-feature__text">
                                    <strong>Fast Result</strong>
                                    <small>तेज रिजल्ट</small>
                                </span>
                            </div>
                            <div className="homescreen-feature" role="listitem">
                                <span className="homescreen-feature__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M12 3 5 6.2v5.3c0 4.3 2.9 8.2 7 9.5 4.1-1.3 7-5.2 7-9.5V6.2L12 3z" />
                                        <path d="m9 12 2 2 4-4" />
                                    </svg>
                                </span>
                                <span className="homescreen-feature__text">
                                    <strong>Fast Deposit</strong>
                                    <small>जल्दी जमा</small>
                                </span>
                            </div>
                            <div className="homescreen-feature" role="listitem">
                                <span className="homescreen-feature__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="7" width="18" height="13" rx="2.2" />
                                        <path d="M3 10h18" />
                                        <path d="M16 15.2h2.2" />
                                    </svg>
                                </span>
                                <span className="homescreen-feature__text">
                                    <strong>Fast Withdraw</strong>
                                    <small>तुरंत निकासी</small>
                                </span>
                            </div>
                        </div>

                        <p className="homescreen-markets">
                            <span aria-hidden="true">◆</span>
                            <span>सभी प्रमुख मटका मार्केट उपलब्ध</span>
                            <span aria-hidden="true">◆</span>
                        </p>

                        <h2 className="homescreen-rates-banner">FULL RATES (सर्वोत्तम रेट्स)</h2>

                        <div className="homescreen-rates">
                            {heroRates.map((item) => (
                                <article className="homescreen-rate-card" key={item.id}>
                                    <h3 className="homescreen-rate-card__label">{item.label}</h3>
                                    <p className="homescreen-rate-card__value">1 KA {item.value}</p>
                                </article>
                            ))}
                        </div>

                        <a
                            href={appLink}
                            className="homescreen-cta text-decoration-none"
                            onClick={(event) => {
                                event.preventDefault();
                                openStar123Download({ appLink });
                            }}
                        >
                            Download App
                            <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M10 3.5v9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                <path d="M6.5 9.5 10 13l3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4 16.5h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </a>

                        <div className="homescreen-trust">
                            <div className="homescreen-trust__item">
                                <span className="homescreen-trust__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 3 5 6.2v5.3c0 4.3 2.9 8.2 7 9.5 4.1-1.3 7-5.2 7-9.5V6.2L12 3z" />
                                    </svg>
                                </span>
                                <span>
                                    <strong>100% Secure</strong>
                                    <small>आपकी सुरक्षा हमारी प्राथमिकता</small>
                                </span>
                            </div>
                            <div className="homescreen-trust__item">
                                <span className="homescreen-trust__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                        <path d="M4 14v-1a8 8 0 0 1 16 0v1" />
                                        <rect x="2.8" y="13" width="4.4" height="6.2" rx="1.4" />
                                        <rect x="16.8" y="13" width="4.4" height="6.2" rx="1.4" />
                                        <path d="M12 19.5v1.7" />
                                    </svg>
                                </span>
                                <span>
                                    <strong>24x7 Support</strong>
                                    <small>हमेशा आपके साथ</small>
                                </span>
                            </div>
                            <div className="homescreen-trust__item">
                                <span className="homescreen-trust__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 2.6 14.4 8l5.9.5-4.5 3.8 1.4 5.8L12 15.8 6.8 18.1l1.4-5.8L3.7 8.5 9.6 8 12 2.6z" />
                                    </svg>
                                </span>
                                <span>
                                    <strong>Trusted by Thousands</strong>
                                    <small>हजारों खिलाड़ियों का भरोसा</small>
                                </span>
                            </div>
                        </div>
                    </div>
                </section>

            <section id="" className="container">
                <div className="container">
                    <div className="row d-flex align-items-center justify-content-center p-3 p-lg-5">
                        <div className="col-12">
                            <div className="home-phone-cta">
                                <p className="home-phone-cta__label">Need Help? Call Us Now
                                </p>
                                <div className="home-phone-cta__number">{data.mobileNumber}</div>
                                <div className="home-phone-cta__actions">
                                    <a
                                        className="home-phone-cta__btn home-phone-cta__btn--call d-flex align-items-center justify-content-center text-decoration-none"
                                        href={"tel:" + data.wpNumber}
                                    >
                                        <FontAwesomeIcon size="lg" className="home-phone-cta__icon" icon={faPhone} />
                                        Call Now
                                    </a>
                                    <a
                                        className="home-phone-cta__btn home-phone-cta__btn--whatsapp d-flex align-items-center justify-content-center text-decoration-none"
                                        target="_blank"
                                        rel="noreferrer"
                                        href={"https://wa.me/" + data.wpNumber}
                                    >
                                        <FontAwesomeIcon size="xl" className="home-phone-cta__icon" icon={faWhatsapp} />
                                        WhatsApp
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                {
                    data?.games ?
                        <GameRates games={data.games} />
                        : <GameRatesSkeleton />
                }

                {
                    data?.winners ?
                        <TopWinners winners={data.winners} />
                        : null
                }

                <div className="row g-3 info-card justify-content-center mb-4" style={{ marginTop: '0' }}>
                    <div className="col-lg-6 col-md-6 info-card">
                        <div className="info-card-wrapper">
                            <div className="info-card-icon-wrapper">
                                <img src={Withdrawal} alt="Fast withdrawals" className='info-card-icon' />
                            </div>
                            <div className="info-card-content">
                                <h5 className="info-card-title"> Fast Withdrawals</h5>
                                <ul className="info-card-list">
                                    <li className="info-card-item">
                                        <span>Fast & Smooth Withdrawals</span>
                                    </li>
                                    <li className="info-card-item">
                                        <span>Withdraw Anytime – 24/7 All Year</span>
                                    </li>
                                    <li className="info-card-item">
                                        <span>Supports All Leading Indian Banks</span>
                                    </li>
                                    <li className="info-card-item">
                                        <span>Most Payouts Completed Within 1 min ⚡</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6 info-card">
                        <div className="info-card-wrapper">
                            <div className="info-card-icon-wrapper">
                                <img src={Support1} alt="24/7 customer support" className='info-card-icon' />
                            </div>
                            <div className="info-card-content">
                                <h5 className="info-card-title">Support Available 24/7</h5>
                                <ul className="info-card-list">
                                    <li className="info-card-item">
                                        <span>Customer Assistance Available 24x7</span>
                                    </li>
                                    <li className="info-card-item">
                                        <span>Help Available in Multiple Languages</span>
                                    </li>
                                    <li className="info-card-item">
                                        <span>English, हिंदी, मराठी & ગુજરાતી Support</span>
                                    </li>
                                    <li className="info-card-item">
                                        <span>Reach Us via Chat, Call, or WhatsApp</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            {/* {
                data?.winners ?
                    <TopWinners winners={data.winners} />
                    : null
            } */}
            {/* 
            {
                data?.games ?
                    <GameRates games={data.games} />
                    : <GameRatesSkeleton />
            } */}

            <Service />

            {
                data?.markets?.length ?
                    <AvailableGames marketsData={data.markets} />
                    : <AvailableGamesSkeleton />
            }

            {
                data?.starlines?.length ?
                    <StarlineGames starlineData={data.starlines} />
                    : <StarlineGamesSkeleton />
            }

            {
                data?.jackpots?.length ?
                    <JackpotGames jackpotData={data.jackpots} />
                    : <JackpotGamesSkeleton />
            }

            <InfoSection />

            <FAQs />

            <SocialIcons wp={data.wpNumber} tele={data.teleNumber} />
                </div>
            </div>
        </>
    );
}

export default Home;
